<div class="catalog-activity flex-start-start width-100p mb-4 position-relative" style="width: 700px;">

  <div class="activity-data-time flex-column">
    <p class="m-0 font-black font-12">
      <!-- 10:45 PM -->
      {{activityLog?.time}}
    </p>

    <div class="flex-start font-12 font-gray-35">
      <p class="m-0"></p>
      {{activityLog?.date}}
    </div>
  </div>

  <div class="flex-row width-100p">
    <div class="activity-icon-wrapper flex-center-start">
      <div class="activity-icon flex-center-center text-transform-uppercase" [ngClass]="{ 'core-activity': true }">
        <span class="font-16 font-800 activity-icon-name-initilas"></span>
      </div>
      <div class="line"></div>
    </div>

    <div class="activity-overview flex-column">
      <p class="m-0">
        <span class="font-12 font-700 font-black font-bold"> {{ helperService.getLocalizationValue(this.currentLang, activityLog, 'title') || activityLog?.actionType}} </span>
        <span class="font-10 secondary-900"> by {{activityLog?.actionBy}} </span>
        <span class="font-10 secondary-900" *ngIf="activityLog?.shopName"> at <span class="font-12 font-700 font-black font-bold">{{activityLog?.shopName}}</span> </span>
      </p>
  
      <div class="flex-start font-12">
        <p class="m-0">
          <span class="font-primary pointer" *ngIf="activityLog?.orderId"
            (click)="navigateToPO(activityLog)">{{activityLog?.poNumber}} &nbsp;</span>
  
          <span [innerHtml]="helperService.getLocalizationValue(this.currentLang, activityLog, 'text')"></span>
        </p>
      </div>
    </div>
  </div>
</div>
